import React from "react";
import { Box, InputLabel, Typography } from "@mui/material";

const DataBlock = ({ key, title, value, variant, className }: any) => {
  if (!value) {
    return null;
  }

  return (
    <Box key={key} className={className}>
      <InputLabel>{title}</InputLabel>
      {variant === "inline" ? (
        <Typography fontSize={14} fontWeight={500} className="text-14-medium" style={{ color: "#333" }}>{value}</Typography>
      ) : (
        <Typography fontSize={14} fontWeight={400}  className="text-14-regular" style={{ color: "#333" }}>{value}</Typography>
      )}
    </Box>
  );
};
export default DataBlock;
